var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isActiveStep(_vm.step)
    ? _c(
        "StepWrapper",
        { attrs: { step: _vm.step } },
        [
          _c(
            "div",
            { staticClass: "solutionguide__properties" },
            _vm._l(_vm.sortedCommonProperties, function (property) {
              return _c("div", { staticClass: "solutionguide__property" }, [
                _c("img", {
                  staticClass: "solutionguide__property-icon",
                  attrs: {
                    src: property.icon,
                    alt: property.name,
                    width: "100",
                    height: "100",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "solutionguide__property-label" }, [
                  _vm._v(_vm._s(property.name)),
                ]),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _vm.sortedAdditionalProperties.length > 0
            ? [
                _c("p", { staticClass: "lead" }, [
                  _vm._v(_vm._s(_vm.$t("property.headline2"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "solutionguide__grid" },
                  _vm._l(_vm.sortedAdditionalProperties, function (property) {
                    return _c(
                      "div",
                      {
                        staticClass: "solutionguide__grid-item",
                        class: _vm.isPropertySelected(property.id)
                          ? "solutionguide__grid-item--selected"
                          : _vm.isPropertyDisabled(property.id)
                          ? "solutionguide__grid-item--disabled"
                          : "",
                        on: { click: () => _vm.toggleProperty(property.id) },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: {
                              mouseleave: ($event) => $event.target.blur(),
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "solutionguide__grid-icon",
                              attrs: {
                                src: property.icon,
                                alt: property.name,
                                width: "100",
                                height: "100",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "solutionguide__grid-label" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(property.name) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _c("p", { staticClass: "lead" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button-wrapper spaced" },
            [
              _c(
                "GlobalButton",
                { attrs: { theme: "secondary" }, on: { click: _vm.back } },
                [_vm._v(_vm._s(_vm.$t("property.button.back")))]
              ),
              _vm._v(" "),
              _c(
                "GlobalButton",
                { attrs: { theme: "primary" }, on: { click: _vm.next } },
                [_vm._v(_vm._s(_vm.$t("property.button.next")))]
              ),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }